import React, { useEffect, useState } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import Loading from './Loading';

const EXCLUDE_PATH_REGEX = /^\/(portal\/dashboard|search)(\/|$)/; // skip loader on dashboard & search page

/**
 * RouteChangeLoader
 * ------------------
 * Shows a global, fullscreen loading overlay for a short period
 * every time the user navigates to a different route. The loader
 * is skipped on the very first render to avoid visual flicker on
 * initial page load (there is already a dedicated app loader for that).
 */
const RouteChangeLoader: React.FC = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (navigationType !== 'PUSH' || EXCLUDE_PATH_REGEX.test(location.pathname)) {
      // Ignore initial load (POP) and dashboard page inside portal
      return;
    }

    setIsLoading(true);
    const timeout = setTimeout(() => setIsLoading(false), 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [location.pathname, navigationType]);

  if (!isLoading) return null;

  return <Loading variant="overlay" />;
};

export default RouteChangeLoader; 